import React from 'react';

import ViskaRedLogo from '../viska-red.png';
import ViskaRedLogoRetina from '../viska-red@2x.png';

import './Support.css';

export default () =>
  <div className="Support">
    <div className="Support__header">
      <a href="/">
        <img
          className="Support__header__logo"
          src={ViskaRedLogo}
          srcSet={`${ViskaRedLogoRetina} 2x`}
          alt="Viska"
        />
      </a>
    </div>
    <div className="Support__content">
      <div className="Support__content__message">
        Need help with Viska? You’ve come to the right place! Send an email to
        us at
        {' '}
        <a href="mailto:support@viskalearning.com">support@viskalearning.com</a>
        .
      </div>
    </div>
  </div>;



// WEBPACK FOOTER //
// ./src/pages/Support.js